export default __webpack_public_path__ + "static/media/logo.5ff05f8e.svg";